import { useState, useEffect } from 'react';
import { gameOverScenarios } from '../selectors/getGameOverState';

export default (abstractGameCode, scenario) => {
    const [gameOverIsOpen, setGameOverIsOpen] = useState(false);
    const { ACTIVE_TIEBREAKER } = gameOverScenarios;

    useEffect(() => {
        if (abstractGameCode === 'F' || scenario === ACTIVE_TIEBREAKER) {
            setGameOverIsOpen(true);
        }
    }, [abstractGameCode, scenario]);

    return [gameOverIsOpen, setGameOverIsOpen];
};
